import { v4 as uuid } from "uuid";

import Api from "@/api/Api";
import { API_ROUTES, requestTokens } from "@/settings/apiRoutes";
import { Advertiser } from "@/store/modules/planCreate";
import { AdvertiserExtendedListEntity, AdvertiserListEntity } from "@/types/plans";

export default class AdvertisersApi {
  async getAllAdvertisers(full = false): Promise<AdvertiserListEntity[] | AdvertiserExtendedListEntity[]> {
    const params = full ? { full: "" } : {};
    return await Api.request<AdvertiserListEntity[] | AdvertiserExtendedListEntity[]>({
      path: `${API_ROUTES.ADVERTISERS.PATH}`,
      method: "get",
      params: params,
      token: requestTokens.apiGetAdvertisers,
      defaultResult: [],
    });
  }

  async getAdvertisersByAgency(agencyName: string): Promise<AdvertiserListEntity[] | AdvertiserExtendedListEntity[]> {
    return await Api.request<AdvertiserListEntity[] | AdvertiserExtendedListEntity[]>({
      path: `${API_ROUTES.ADVERTISERS.PATH}`,
      method: "get",
      params: { agency_name: agencyName },
      token: requestTokens.apiGetAdvertisers,
      defaultResult: [],
    });
  }

  async getAllAdvertiserByID(id: string): Promise<Advertiser> {
    return await Api.request<Advertiser>({
      path: `${API_ROUTES.ADVERTISERS.PATH}/${id}`,
      method: "get",
      token: requestTokens.apiGetAdvertiser,
      defaultResult: {
        id: "",
        name: "",
      },
    });
  }

  async updateAdvertiserById(id: string, payload: Advertiser): Promise<Advertiser> {
    return await Api.request<Advertiser>({
      path: `${API_ROUTES.ADVERTISERS.PATH}/${id}`,
      method: "put",
      token: requestTokens.apiUpdateAdvertiser,
      body: payload,
      defaultResult: {
        id: "",
        name: "",
      },
    });
  }

  async createAdvertiser(payload: Omit<Advertiser, "id">): Promise<Advertiser> {
    const payloadWithId = {
      id: uuid(),
      ...payload,
    };

    return await Api.request<Advertiser>({
      path: API_ROUTES.ADVERTISERS.PATH,
      method: "post",
      token: requestTokens.apiCreateAdvertiser,
      body: payloadWithId,
      defaultResult: {
        id: "",
        name: "",
      },
    });
  }
}
